
import dayjs from 'dayjs';
import {
  CheckIcon,
  PhoneIncomingIcon,
  ChatAltIcon,
  PlayIcon,
} from '@vue-hero-icons/outline';
import { CONTANTS } from '~/constants';
export default {
  components: {
    CheckIcon,
    PhoneIncomingIcon,
    ChatAltIcon,
    PlayIcon,
  },

  layout: 'default',

  fetchOnServer: false,

  head() {
    return {
      title: this.metaTitle,
      meta: [
        { hid: 'title', name: 'title', content: this.metaTitle },
        { hid: 'description', name: 'description', content: this.metaDesc },
        { hid: 'image', name: 'image', content: this.metaImage },
        { hid: 'og:url', property: 'og:url', content: this.routePath },
        { hid: 'og:title', property: 'og:title', content: this.metaTitle },
        { hid: 'og:image', property: 'og:image', content: this.metaImage },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: this.metaImage,
        },
        {
          hid: 'og:image:secure',
          property: 'og:image:secure',
          content: this.metaImage,
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.metaTitle,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDesc,
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.metaTitle,
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content: this.metaTitle,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.metaDesc,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.metaImage,
        },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: `${this.canonical}`,
        },
      ],
      script: [
        {
          innerHTML: `{
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${this.routePath}"
            },
            "headline": "${this.metaTitle}",
            "image": "${this.metaImage}",
            "datePublished": "${this.datePublished}",
            "dateModified": "${this.datePublished}",
            "author": {
              "@type": "Person",
              "name": "${CONTANTS.SITE_SHORT}",
              "url": "${this.routePath}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "${CONTANTS.SITE_SHORT}",
              "logo": {
                "@type": "ImageObject",
                "url": "${this.metaImage}"
              }
            }
          }`,
          type: 'application/ld+json',
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    };
  },
  data() {
    this.USER_PLAN = CONTANTS.USER_PLAN;
    return {
      subscriptions: [],
      filterForm: {
        searchQuery: '',
        statusFilter: '',
      },
      activeFilters: {
        searchQuery: '',
        statusFilter: '',
      }
    };
  },

  async fetch() {
    await this.getSubscriptions();
  },

  computed: {
    datePublished() {
      return new Date().toISOString();
    },
    metaTitle() {
      return `${this.$t("meta.admin_title")} | ${CONTANTS.SITE_SHORT}`;
    },

    metaDesc() {
      return `${this.$t("meta.admin_title")} | ${CONTANTS.SITE_SHORT}`;
    },

    metaImage() {
      return `${this.$config.protocol}://${this.$config.baseHost}/images/metacanhanf.jpeg`;
    },

    routePath() {
      return `http://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    canonical() {
      return `https://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    firstPlan() {
      return this.$get(this.plans, '[0].id');
    },

    customer() {
      return this.$get(this.$$users, 'user', '');
    },

    filteredSubscriptions() {
      let filtered = [...this.subscriptions]
      
      if (this.activeFilters.searchQuery) {
        const query = this.activeFilters.searchQuery?.toLowerCase()
        filtered = filtered.filter(sub => 
          (sub.user.email || sub.user.username)?.toLowerCase().includes(query)
        )
      }

      if (this.activeFilters.statusFilter) {
        filtered = filtered.filter(sub => 
          this.activeFilters.statusFilter === 'active' ? sub.is_active : !sub.is_active
        )
      }

      return filtered
    }
  },

  methods: {
    hasApproval(sub) {
      return !sub?.is_active && sub?.plan?.category !== 'free';
    },

    getFormatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY') : 'N/A';
    },

    getCustomerStatus(isActive) {
      return isActive ? 'Đang hoạt động' : 'Miễn phí';
    },

    async getSubscriptions() {
      const { data } = await this.$axios.request({
        url: '/api/user/subscribe/',
        method: 'get',
      });

      this.subscriptions = data?.results;
    },

    makingFormData(plan) {
      if (!plan) return null;
      const today = dayjs();
      let expiring_on = '';

      const formData = {
        subscribed_on: today.format('YYYY-MM-DD HH:mm:ss'),
      };

      if (plan?.category === 'monthly') {
        expiring_on = today.add(1, 'month').format('YYYY-MM-DD HH:mm:ss');
      }

      if (plan?.category === 'haft') {
        expiring_on = today.add(6, 'month').format('YYYY-MM-DD HH:mm:ss');
      }

      if (plan?.category === 'yearly') {
        expiring_on = today.add(1, 'year').format('YYYY-MM-DD HH:mm:ss');
      }

      formData.expiring_on = expiring_on;

      return formData;
    },

    async approve(sub) {
      if (!sub) return;

      if (sub.is_active) return;

      const { id, plan } = sub;

      const message = 'Bạn chắc chắn?';
      const confirm = await this.$vmodal.confirm({ message });
      if (!confirm) {
        return;
      }

      const formData = this.makingFormData(plan);

      if (!formData?.expiring_on || !formData?.subscribed_on) {
        this.$toast.open({
          type: 'warning',
          message: 'Xuất hiện lỗi trong quá trình phê duyệt',
        });

        return;
      }

      const { data } = await this.$axios.request({
        url: `/api/user/subscribe/${id}/`,
        method: 'put',
        data: formData,
      });

      if (data) {
        this.$toast.open({
          message: 'Tài khoản đã được phê duyệt',
        });

        await this.getSubscriptions();
      }
    },

    applyFilters() {
      // Copy filter form values to active filters
      this.activeFilters = { ...this.filterForm };
    },

    resetFilters() {
      // Reset both form and active filters
      this.filterForm = {
        searchQuery: '',
        statusFilter: '',
      };
      this.activeFilters = {
        searchQuery: '',
        statusFilter: '',
      };
    },
  },
};
